// Library Class
import { Component, OnInit, AfterViewInit, HostListener, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';
import { AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { StockTransferAddProductSliderModelService } from '../sot-add-product/sot-add-product.component-slider-model.service';
import { SOTService } from '../../../../services/seed/sot/sot.service';
import { LocalStorageService } from '../../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../../../common/constants/master-constants';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { StockTransferSelectAccountSliderModelService } from '../sot-select-account/sot-select-account.component-slider-model.service';
import { BroadcastService } from '../../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../../services/infrastructure/config.service';
import { ConfirmDialogComponent } from '../../../../common/components/confirm-dialog/confirm-dialog.component';
import { StockRequestHistorySliderModelService } from '../sot-request-history/sot-request-history.component-slider-model.service';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { CommonService } from '../../../../services/common/common.service';

@Component({
  selector: 'app-sot-request-entry',
  templateUrl: './sot-request-entry.component.html',
  styleUrls: ['./sot-request-entry.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('detailExpandDelivery', [
      state('collapsedDelivery', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('expandedDelivery', style({ height: '*' })),
      transition('expandedDelivery <=> collapsedDelivery', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('detailExpandDeliveryMobile', [
      state('expandedDeliveryMobile', style({ height: '0px', minHeight: 0, display: 'none' })),
      state('collapsedDeliveryMobile', style({ height: '*' })),
      transition('collapsedDeliveryMobile <=> expandedDeliveryMobile', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})

export class StockTransferRequestEntryComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  freightInstruction: any = [];
  fromContactName = '';
  fromContactNumber = '';
  fromCustomerPONumber = '';
  fromShippingInstructions = '';
  selectedFreightInstructionOptions: any = [];
  deliveryAccountList: Array<any> = [];
  fromDeliveryAccount: number;
  addProductsSubscription: any;
  checkBoxCount = 0;
  currentErrorRow = 1;
  dateFilter: any;
  date = new Date();
  deliverToAnotherLocation = false;
  deliveryOption = 0;
  deliveryOptionList = [
    { id: 1, value: 'ALREADY MOVED-TO ACCOUNT FREIGHT ALLOWANCE' },
    { id: 2, value: 'ALREADY MOVED-FROM ACCOUNT FREIGHT ALLOWANCE' },
    { id: 3, value: 'ALREADY MOVED-WFU EMPLOYEE' },
    { id: 4, value: 'WFU ARRANGED' }
  ];
  desiredDelDate = new Date();
  isMobile = /Android|iPhone/i.test(window.navigator.userAgent);
  disablecheckbox: any;
  disableWFUArranged = true;
  disableAlreadyMovedToOrFrom = false;
  displayedColumns: string[] = ['checkbox', 'product', 'packageSize', 'lotNumber', 'treatment', 'productLine', 'availability', 'requestedQty'];
  editToolKit = false;
  errorMsgs = new Array();
  filteredDataCount = 0;
  filterInvoicedProductitems: any[] = [];
  filterValueList: any = [];
  fromCity = '';
  fromCountry = '';
  fromDesiredPickupDate: any = new Date(this.desiredDelDate);
  fromNonStockPallet = 0;
  fromParentShipToAccount: any;
  fromShipToAccount: number;
  fromShipToAccountItems: any[];
  fromShipToDataLoading = true;
  fromStockPallet = 0;
  fromCBox = 0;
  headerCompany = MasterConstants.US_COMPANYCODE;
  index: any;
  invoicedProductList: any = [];
  isAddProductEnable = false;
  isAllProductChecked = false;
  isContactValid: boolean;
  isDraftEnable = false;
  isEditMode = false;
  isEditingOrRejected = false;
  isEditingRequest = false;
  isExpanded = true;
  isExpandedDelivery = true;
  isExpandedDeliveryMobile = true;
  isNameValid: boolean;
  isPalletValid: boolean;
  isPickupDateValid = true;
  isSearchClicked: any;
  isSubmitEnable = false;
  isValidLineStatus = false;
  marketingBrandMasterList: any[];
  maxDate = new Date(this.date.setMonth(this.date.getMonth() + 6));
  maxTransferDistance: any;
  minDate = new Date();
  minProductQtyBG: any;
  nextErrorId = 0;
  nextLotNumber: string;
  orderNumber: string;
  packageSizeMasterList: any = [];
  partialSearchValue = '';
  productFilters: any;
  productItemsDataSource: any;
  productListCopy: any;
  productList: any[];
  productLineList: any = [];
  productSearchFilter: string;
  qtyCount = 0;
  readOnlyAccess = false;
  rejectionReason: string;
  requestStatus: string;
  resolutionComment: string;
  searchTypeList: any = [
    { name: 'Product Name', value: 'productName' },
    { name: 'Product Line', value: 'productLine' },
    { name: 'Lot #', value: 'lotNumber' },
    { name: 'Item #', value: 'itemNumber' },
    { name: 'Package Size', value: 'packageSize' },
    { name: 'Treatment', value: 'treatmentDescription' },
    { name: 'Marketing Brand', value: 'marketingBrand' },

  ];
  searchValue = '';
  selectedCount = 0;
  showErrorBlock = false;
  showTabs = false;
  sotConfigurationList: any;
  sotOriginalProductItemsDataSource: any;
  sotRequestId: number;
  subscription = new Subscription();
  tabNode: string;
  toAccount: any = {};
  toAccountName = false;
  toCity = '';
  toCountry = '';
  toParentShipToAccount: any;
  toShipToAccount: number;
  travelDistance = 0;
  treatmentMasterList: any[];
  userIdRole: string;
  userMenuAccessList: any;
  isFilterAddProductShow = true;
  fromState = '';
  toState = '';

  constructor(
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private stockTransferAddProductSliderModelService: StockTransferAddProductSliderModelService,
    private stockRequestHistorySliderModelService: StockRequestHistorySliderModelService,
    private stockTransferSelectAccountSliderModelService: StockTransferSelectAccountSliderModelService,
    private stockTransferService: SOTService,
    private toastrService: ToastrService,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {

    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.SOT_STOCK_TRANSFERS);

    this.subscription.add(this.stockTransferService.getSotConfigurationList().subscribe((result: any[]) => {
      this.sotConfigurationList = result;
      this.minProductQtyBG = this.sotConfigurationList.filter(i => i.configIdname == 'MinProductQTY_BG');
      this.minProductQtyBG = this.minProductQtyBG[0].configIdvalue;
      this.maxTransferDistance = this.sotConfigurationList.filter(i => i.configIdname == 'MaxTransferDistance');
      this.maxTransferDistance = this.maxTransferDistance[0].configIdvalue;
    }));

    this.getAccountList();
    this.getFreightList();
    this.productItemsDataSource = new MatTableDataSource([]);
    this.sotOriginalProductItemsDataSource = this.productItemsDataSource.data;
    this.clearAllFilter();
    this.setDropDownValues();
    this.bindDataSource([]);

    // Logic for Add Product Grid
    this.subscription.add(this.stockTransferAddProductSliderModelService.stockTransferAddModelData.subscribe(selectedProductList => {
      this.selectedCount = selectedProductList.length;

      if (selectedProductList.length > 0) {
        this.formatNewAddedData(selectedProductList, false);
        this.enableDisableButtons();
      }
    }));

    this.subscription.add(this.stockTransferSelectAccountSliderModelService.sotSelectAccountAddModelData.subscribe(selectedAccount => {
      if (selectedAccount.accountName) {
        this.toAccountName = true;
        this.toAccount = selectedAccount;
        this.toShipToAccount = selectedAccount.accountNumber;
        this.toParentShipToAccount = selectedAccount.parentNumber;
        this.toCountry = selectedAccount.country;
        this.toCity = selectedAccount.city;
        this.toState = selectedAccount.state;
        this.distanceApiAfterToAcountSelect();
        this.enableDisableButtons();
        this.disableWFUArrangedButton();
      }
    }));

    if (this.stockTransferService.sotRequestId > 0) {
      this.sotRequestId = this.stockTransferService.sotRequestId;
      this.isEditMode = true;
      this.getOrderDetails();
      this.enableDisableButtons();
    }
  }

  // Observe Input element change
  ngOnChanges(changes: SimpleChanges) {
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setHeight();
  }

  // Design
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setHeight();
  }

  // Design : Set height
  setHeight() {
    if (window.innerWidth > 767) {
      const tableHeight = window.innerHeight - 85;
      $('.requestCOIOuter').css('height', tableHeight + 'px');
    }
    // else {
    //  const tableHeight = window.innerHeight - 15;
    //  $('.requestCOIOuter').css('height', tableHeight + 'px');
    // }
  }

  addProduct() {
    this.stockTransferAddProductSliderModelService.shipToAccount = this.fromShipToAccount;
    this.stockTransferAddProductSliderModelService.activeSlider('AddStockTransferProductSlider');
  }

  selectAccount() {
    // nagivate to select Account slider;
    this.stockTransferService.setSelectedAccountNo(this.fromShipToAccount);
    this.stockTransferSelectAccountSliderModelService.activeSlider('SOTSelectAccountSlider');
  }

  // Toggle Pickup Section
  togglePickup() {
    this.isExpanded = !this.isExpanded;
  }

  togglePickupDelivery() {
    this.isExpandedDelivery = !this.isExpandedDelivery;
  }

  toggleDeliveryMobile() {
    this.isExpandedDeliveryMobile = !this.isExpandedDeliveryMobile;
  }

  setExpanded() {
    if (this.fromShipToAccount && this.toAccount) {
      this.isExpanded = false;
    }
    else {
      this.isExpanded = true;
    }
  }

  getAccountList() {
    this.subscription.add(this.stockTransferService.getFromAccountList().subscribe((result: any[]) => {
      this.fromShipToAccountItems = result;
      this.fromShipToDataLoading = false;
      if (this.fromShipToAccount) {
        const accountItem = this.fromShipToAccountItems.filter(x => x.accountNumber === this.fromShipToAccount);
        if (accountItem) {
          this.fetchDeliverToFacilityList(accountItem[0].accountNumber, accountItem[0].parentNumber);
        }
      }
      this.loaderService.setLoaderStatus(false);
    }, ((error) => {
      this.loaderService.setLoaderStatus(false);
      this.fromShipToDataLoading = false;
    })));
    this.productSearchFilter = this.searchTypeList[0].value;
  }

  // Search the account details on shipto / Deliverto dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Enable/Disable Save Draft Button and Place Order Button
  enableDisableButtons() {
    if (this.fromShipToAccount && this.toShipToAccount) {
      this.isExpanded = false;
      this.isAddProductEnable = true;
      if (this.productItemsDataSource && this.productItemsDataSource.data && this.productItemsDataSource.data.length > 0) {
        this.isDraftEnable = true;
        this.isSubmitEnable = true;
      }
      else {
        this.isDraftEnable = false;
        this.isSubmitEnable = false;
      }
    }
    else {
      this.isAddProductEnable = false;
      this.isExpanded = true;
      this.isDraftEnable = false;
      this.isSubmitEnable = false;
    }
    if (this.requestStatus && this.requestStatus.toUpperCase() === 'EDITING') {
      this.isSubmitEnable = true;
    }
  }

  // Format Data from Add Product Slider Model
  formatNewAddedData(productList: any[], isEditData) {
    const orderList = [];
    this.filteredDataCount = 0;
    let rowId = 0;
    this.productItemsDataSource.data.forEach(x => {
      orderList.push(x);
      if (x.rowId > rowId) { rowId = x.rowId; }
    });

    productList.forEach(x => {
      rowId = rowId + 1;
      const duplicateData = orderList.find(y => y.itemId == x.itemId && y.orderUOM == x.orderUOM && y.lotNumber == x.lotNumber);
      if (duplicateData == undefined) {
        const newRow = {
          rowId: rowId,
          isSelected: false,
          isProductDetailDisplayed: false,
          itemId: x.itemId,
          itemNumber: x.itemNumber,
          itemDescription: x.itemDescription,
          itemVendorName: x.itemVendorName,
          packageSize: x.packageSize,
          productLine: x.productLine,
          treatment: x.treatment,
          isParent: x.isParent,
          orderUOM: x.orderUOM,
          lotNumber: x.lotNumber,
          availableQuantity: x.availableQuantity,
          conversionFactor: x.conversionFactor ?? 1,
          requestedQty: isEditData ? x.requestedQty : (x.availableQuantity == 0 ? 0 : x.requestedQty ?? 0),
          lineErrors: { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'orderUOM': x.orderUOM, 'errors': [] },
          lineError: false,
          warningMessage: ""
        };

        this.qtyCount = this.qtyCount + x.orderQty;
        orderList.splice(orderList.length, 0, newRow);
        this.productListCopy = JSON.parse(JSON.stringify(orderList));
      }
      else {
        duplicateData.availableQuantity = x.availableQuantity;
      }
    });

    this.filteredDataCount = orderList.length;
    this.productItemsDataSource.data = orderList;
    this.sotOriginalProductItemsDataSource = JSON.parse(JSON.stringify(orderList));
    this.bindDataSource(orderList);

    if (this.productItemsDataSource.data.length > 0) {
      this.disablecheckbox = false;
    }
    else {
      this.disablecheckbox = true;
    }
  }

  saveRequest(requestStatus) {
    if (this.validateOrder()) {
      $('#cppOrderView').animate({ scrollTop: 0 }, 'slow');

      const saveObj: any = {};
      saveObj.companyCode = this.headerCompany;
      saveObj.fromAccount = this.fromShipToAccount;
      saveObj.fromPickupLocation = this.fromDeliveryAccount;
      saveObj.fromRequestDate = (new Date(this.fromDesiredPickupDate)).toLocaleDateString('en-US').replace(/\u200E/g, '');
      saveObj.fromCustPONumber = this.fromCustomerPONumber;
      saveObj.fromHeaderText = this.fromShippingInstructions;
      saveObj.fromContactName = this.fromContactName;
      saveObj.fromContactNumber = this.fromContactNumber;
      saveObj.fromFreightInstructions = this.selectedFreightInstructionOptions ? this.selectedFreightInstructionOptions.map(x => x.id).join() : '';
      saveObj.fromStockPalletCount = this.fromStockPallet;
      saveObj.fromNonStockPalletCount = this.fromNonStockPallet;
      saveObj.fromCBoxCount = this.fromCBox;
      saveObj.toAccount = this.toShipToAccount;
      saveObj.deliveryOptions = this.deliveryOption;
      saveObj.requestStatus = requestStatus;
      saveObj.isUpdateRequest = this.sotRequestId && this.sotRequestId > 0 ? true : false;
      saveObj.sotrequestId = this.sotRequestId;
      saveObj.FromToRequest = 'FROM';
      saveObj.resolutionComment = this.resolutionComment;
      saveObj.sotProductList = this.productItemsDataSource.data;
      if ((this.fromShippingInstructions && (this.fromShippingInstructions != ''))) {
        saveObj.fromSpecialInstCode = 41;
      }

      this.loaderService.setLoaderStatus(true);
      this.subscription.add(this.stockTransferService.saveOrder(saveObj).subscribe((result: any) => {
        if (result) {
          if (result.errors.length > 0) {
            this.loaderService.setLoaderStatus(false);
            result.errors.forEach(x => {
              this.toastrService.error(x);
              return false;
            });
          }
          else {
            if (requestStatus == 'SUBMITTED' || requestStatus == 'PENDING') {
              const successMsg = 'Order #' + result.sotrequestNumber + ' submitted successfully.';
              this.toastrService.success(successMsg);
              this.router.navigate(['/sot-request-review/' + result.sotrequestId + '/' + 1]);
            } else {
              const successMsg = (this.isEditMode) ? 'Order #' + result.sotrequestNumber + ' updated successfully.' : 'Order #' + result.sotrequestNumber + ' saved successfully.';
              this.toastrService.success(successMsg);
              this.navigateToLandingPage();
            }

            this.broadcastService.broadcast(this.configService.DATA_CHANGE, { updateButtonClick: true });
            this.loaderService.setLoaderStatus(false);
          }
        }
      }, (error) => {
        this.loaderService.setLoaderStatus(false);
        this.toastrService.error('Order not saved in the system.');
        LolLoggerService.error(error);
      }));
    }
  }

  desiredPickupDateValid(pickupDate: AbstractControl) {
    if (pickupDate.valid && pickupDate['model'] >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  ValidateSelectedDesiredPickupDate(event) {
    if (event.value && event.value >= new Date(new Date().setHours(0, 0, 0, 0))) {
      this.isPickupDateValid = true;
    } else {
      this.isPickupDateValid = false;
    }
  }

  countShouldBeValid(count: AbstractControl) {
    this.isPalletValid = count.valid;
  }

  phoneShouldBeValid(phone: AbstractControl) {
    this.isContactValid = phone.valid;
  }

  nameShouldBeValid(name: AbstractControl) {
    this.isNameValid = name.valid;
  }

  updateDeliverToSelection(isDeliverToOptionChecked) {
    if (!isDeliverToOptionChecked) {
      this.fromDeliveryAccount = null;
    }
  }

  validateDateFilter() {
    this.dateFilter = (d: Date): boolean => {
      const currentDate = new Date();
      currentDate.setDate(currentDate.getDate() - 1);
      const calendarDate = d;
      // Prevent Saturday and Sunday from being selected.
      return calendarDate >= currentDate;
    };
  }

  openRequestHistorySlider() {
    this.stockRequestHistorySliderModelService.sotRequestId = this.sotRequestId;
    this.stockRequestHistorySliderModelService.activeSlider('SOTRequestHistorySlider');
  }

  enableAllCheckBoxes(isChecked) {
    this.isAllProductChecked = isChecked;
    if (isChecked) {
      this.isSearchClicked = false;
      this.showTabs = true;
      this.editToolKit = true;
      this.productItemsDataSource.data.forEach(x => {
        x.isSelected = true;
      });
      this.checkBoxCount = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true).length;
      const selectedItem = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true);
      if (selectedItem && selectedItem.length > 0) {
        this.editToolKit = true;
        if (this.stockTransferService.getEditModeStatus()) {
          this.showTabs = true;
          this.isSearchClicked = false;
        }

        this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == null || item.lineStatus == '' || item.lineStatus == 'DRAFT' || item.returnRequestItemId == 0).length > 0 ? true : false;
      }
      else {
        this.editToolKit = false;
      }
    }
    else {
      this.showTabs = false;
      this.editToolKit = false;
      this.productItemsDataSource.data.forEach(x => {
        x.isSelected = false;
      });
      this.checkBoxCount = 0;
    }
  }

  enableCheckBoxSingle(isChecked) {
    if (isChecked) {
      this.editToolKit = true;
      this.isSearchClicked = false;
      this.showTabs = true;

      this.checkBoxCount = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true).length;
      const checked = this.productItemsDataSource.filteredData.filter(x => x.isSelected == false);

      if (checked && checked.length == 0) {
        this.isAllProductChecked = true;
      }
      else {
        this.isAllProductChecked = false;
      }
    }
    else {
      this.checkBoxCount = this.checkBoxCount - 1;
      this.isAllProductChecked = false;
      const selected = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true);
      {
        if (selected && selected.length == 0) {
          this.showTabs = false;
        }
        else {
          this.showTabs = true;
        }
      }
    }
    this.editToolKit = false;
    const selectedItem = this.productItemsDataSource.filteredData.filter(x => x.isSelected == true);
    this.isValidLineStatus = false;
    if (selectedItem.length > 0) {
      this.isValidLineStatus = selectedItem.filter(item => item.lineStatus == '' || item.lineStatus == null || item.lineStatus == 'DRAFT' || item.returnRequestItemCppId == 0).length > 0 ? true : false;
      this.editToolKit = true;
      if (this.isValidLineStatus && this.stockTransferService.getEditModeStatus()) {
        this.showTabs = true;
        this.isSearchClicked = false;
      } else if (!this.isValidLineStatus && this.stockTransferService.getEditModeStatus()) {
        this.editToolKit = false;
      }
    }
  }

  fetchDeliverToFacilityList(accountNumber: number, parentNumber: number) {
    this.subscription.add(this.stockTransferService.getDeliverToLocationList(accountNumber, parentNumber)
      .subscribe((result: any[]) => {
        this.deliveryAccountList = result;
      }, error => this.loaderService.setLoaderStatus(false))
    );
  }

  getFreightList() {
    if (this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST)) {
      this.freightInstruction = JSON.parse(this.localStorageService.get(MasterConstants.FREIGHT_INSTRUCTION_MASTER_LIST));
    }
  }

  // Set Tab to show
  showTab(tabid: string) {
    this.tabNode = tabid;
  }

  getDeliverTo(event) {
    if (event) {
      this.setValuesForCreateNewReturn(event);
      this.isAddProductEnable = true;
    } else {
      this.fromDeliveryAccount = null;
      this.deliveryAccountList = null;
      this.isAddProductEnable = false;
    }
    this.clearAllFilter();
    this.clearAllFields();
    // reset pickup location checkbox & dropdown if ship to is changed or reset.
    this.deliverToAnotherLocation = false;
    this.fromDeliveryAccount = null;
    this.stockTransferService.setSelectedAccountNo(this.fromShipToAccount);
    this.enableDisableButtons();
  }

  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.resetProductFilter();
    this.applyFilterData(this.productFilters);
    this.selectedCount = 0;
    this.isAllProductChecked = false;
  }

  clearAllFields() {
    this.productItemsDataSource = new MatTableDataSource([]);
    this.deliverToAnotherLocation = null;
  }

  // Qty change on +/- sign click
  unitChange(action: string, productItem: any) {
    productItem.lineErrors.errors = [];
    productItem.warningMessage = "";
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber && element.orderUOM == productItem.orderUOM;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }
    if (action == 'decrease') {
      this.productItemsDataSource.data.forEach(x => {
        if (x.rowId == productItem.rowId) {
          if (productItem.requestedQty > 0) { productItem.requestedQty = +productItem.requestedQty - +1; }
          productItem = this.validateQty(productItem);
          this.disableWFUArrangedButton();
        }
      });
    }
    else {
      this.productItemsDataSource.data.forEach(x => {
        if (x.rowId == productItem.rowId) {
          productItem.requestedQty = +productItem.requestedQty + +1;
          productItem = this.validateQty(productItem);
          this.disableWFUArrangedButton();
        }
      });
    }

    // get old data
    const oldProductLineValue = JSON.parse(JSON.stringify(this.productListCopy)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldStockRquestedQty: oldProductLineValue.requestedQty, newStockRequestedQty: productItem.requestedQty, labelNo: 'No, go back to Request' });
  }

  // Qty change on text change
  textChange(productItem: any) {
    // get old data
    productItem.lineErrors.errors = [];
    const index = this.errorMsgs.findIndex(function (element) {
      return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber && element.orderUOM == productItem.orderUOM;
    });
    if (index !== -1) {
      this.errorMsgs.splice(index, 1);
    }

    const oldProductLineValue = JSON.parse(JSON.stringify(this.productListCopy)).filter(x => x.rowId == productItem.rowId)[0];
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { oldStockRquestedQty: oldProductLineValue.requestedQty, newStockRequestedQty: productItem.requestedQty, labelNo: 'No, go back to Request' });
    productItem = this.validateQty(productItem);
    this.disableWFUArrangedButton();
  }

  setValuesForCreateNewReturn(event) {
    this.fromShipToAccount = event.accountNumber;
    this.fromParentShipToAccount = event.parentNumber;
    this.fromCountry = event.country;
    this.fromCity = event.city;
    this.fromState = event.state;
    this.fetchDeliverToFacilityList(event.accountNumber, event.parentNumber);
    this.distanceApiAfterToAcountSelect();
    this.disableWFUArrangedButton();
  }

  selectProductName($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.productName = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.productName = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.productName = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }
    this.keepFilter();
  }

  selectLotNumber($event) {
    // To check undefined
    if ($event) {
      const selectedValue = $event.target.value;
      if (selectedValue != undefined && selectedValue != null && selectedValue.toString().trim().length >= 2) {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > selectedValue.toString().trim().length) {
          this.productFilters.lotNumber = this.partialSearchValue;
        }
        // To add selected value
        else {
          this.productFilters.lotNumber = selectedValue;
        }
      }
      else {
        // To add partial search value
        if (this.partialSearchValue.toString().trim().length > 2) {
          this.productFilters.lotNumber = this.partialSearchValue;
        }
      }
    }
    else {
      this.resetProductFilter();
    }
    this.keepFilter();
  }

  keepFilter() {
    if (this.filterValueList) {
      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.invoicedProductList && this.productFilters.invoicedProductList.length > 0) {
          let strMB = '';
          this.productFilters.invoicedProductList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Item # : ' + strMB.substr(0, strMB.length - 2));
        }
        // Set Product Name
        if (this.productFilters.productName && this.productFilters.productName != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.productName);
        }

        if (this.productFilters.lotNumber && this.productFilters.lotNumber != '') {
          this.filterValueList.push('Lot # : ' + this.productFilters.lotNumber);
        }

        // Set Package Size
        if (this.productFilters.packageSize && this.productFilters.packageSize.length > 0) {
          var strINO = '';
          this.productFilters.packageSize.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strINO.substr(0, strINO.length - 2));
        }

        // Set Treatment
        if (this.productFilters.treatmentDescription && this.productFilters.treatmentDescription.length > 0) {
          var strINO = '';
          this.productFilters.treatmentDescription.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strINO.substr(0, strINO.length - 2));
        }

        // Set marketing brand
        if (this.productFilters.marketingBrand && this.productFilters.marketingBrand.length > 0) {
          var strINO = '';
          this.productFilters.marketingBrand.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strINO.substr(0, strINO.length - 2));
        }

        // Set product Line
        if (this.productFilters.productLine && this.productFilters.productLine.length > 0) {
          var strINO = '';
          this.productFilters.productLine.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strINO.substr(0, strINO.length - 2));
        }
      }
    }
    this.applyFilterData(this.productFilters);
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Filter grid data on type
  applyFilterData(filterValue: any) {
    this.filterInvoicedProductitems = [];
    this.filteredDataCount = 0;

    this.productItemsDataSource.filter = filterValue;
    this.filterInvoicedProductitems.forEach(item => {
      if (item.isSelected) {
        this.checkBoxCount = this.checkBoxCount + 1;
      }
    });
  }

  resetProductFilter() {
    this.filterValueList = [];
    this.productFilters = {
      'productName': '',
      'treatmentDescription': [],
      'packageSize': [],
      'marketingBrand': [],
      'productLine': [],
      'invoicedProductList': [],
      'lotNumber': '',
    };
  }

  // Set Drop down values for filter
  setDropDownValues() {
    // Marketing brand master data
    if (this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST)) {
      this.marketingBrandMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_MARKETING_BRAND_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packageSizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // Treatment master list
    if (this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST));
    }

    // Product Line data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    // Item Number master data
    if (this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.invoicedProductList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_RETURN_ITEM_NUMBER_MASTER_LIST));
    }
  }

  // Bind data source
  bindDataSource(orderList: any) {
    if (orderList && orderList != null) {
      this.productItemsDataSource = new MatTableDataSource(orderList);
      this.productItemsDataSource.filterPredicate = (data: any, filter: any) => {
        if ((filter.invoicedProductList.length == 0 || (filter.invoicedProductList.indexOf(data.itemNumber.trim()) > -1))
          && (filter.marketingBrand.length == 0 || (filter.marketingBrand.indexOf(data.itemVendorName) > -1))
          && (filter.treatmentDescription.length == 0 || (filter.treatmentDescription.indexOf(data.treatment) > -1))
          && (filter.packageSize.length == 0 || (filter.packageSize.indexOf(data.packageSize) > -1))
          && (filter.productLine.length == 0 || (filter.productLine.indexOf(data.productLine) > -1))
          && (filter.productName == null || (data.itemDescription.trim().toLowerCase().indexOf(filter.productName.trim().toLowerCase()) > -1))
          && (filter.lotNumber == null || (data.lotNumber.trim().toLowerCase().indexOf(filter.lotNumber.trim().toLowerCase()) > -1))) {
          this.filterInvoicedProductitems.push(data);
          this.filteredDataCount = this.filteredDataCount + 1;
          return true;
        }
        else {
          return false;
        }
      };
      this.applyFilterData(this.productFilters);
    }
  }

  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);
      this.applyFilterData(this.productFilters);
    }
  }

  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item #':
        this.productFilters.invoicedProductList = [];
        break;
      case 'Product Name':
        this.productFilters.productName = '';
        break;
      case 'Lot #':
        this.productFilters.lotNumber = '';
        break;
      case 'Marketing Brand':
        this.productFilters.marketingBrand = [];
        break;
      case 'Treatment':
        this.productFilters.treatmentDescription = [];
        break;
      case 'Package Size':
        this.productFilters.packageSize = [];
        break;
      case 'Product Line':
        this.productFilters.productLine = [];
        break;
      default:
        break;
    }
  }

  // Get Order Details when opened in Edit/View Mode
  getOrderDetails() {
    this.loaderService.setLoaderStatus(true);

    this.subscription.add(this.stockTransferService.getSOTEditOrderDetail(this.sotRequestId).subscribe((result: any) => {
      this.orderNumber = result.sotrequestNumber;
      this.fromShipToAccount = result.fromAccount;
      this.fromDeliveryAccount = result.fromPickupLocation;
      this.fromCustomerPONumber = result.fromCustPonumber;
      this.fromShippingInstructions = result.fromHeaderText;
      this.fromParentShipToAccount = result.fromAccountDetail.parentNumber;
      this.fromCountry = result.fromAccountDetail.country;
      this.fromCity = result.fromAccountDetail.city;
      this.fromState = result.fromAccountDetail.state;
      this.fromContactName = result.fromContactName;
      this.fromContactNumber = result.fromContactNumber;
      this.fromDesiredPickupDate = result.fromRequestDate;
      if ((result.requestStatus == 'DRAFT')
        && (new Date(result.fromRequestDate) < new Date())) {
        this.fromDesiredPickupDate = new Date();
      }

      this.selectedFreightInstructionOptions = this.freightInstruction.filter(x => result.fromFreightInstructions.indexOf(x.id) > -1);
      this.fromStockPallet = result.fromStockPalletCount;
      this.fromNonStockPallet = result.fromNonStockPalletCount;
      this.fromCBox = result.fromCBoxCount;
      this.toShipToAccount = result.toAccount;
      this.toAccount = result.toAccountDetail;
      this.toParentShipToAccount = this.toAccount.parentNumber;
      this.toCountry = this.toAccount.country;
      this.toCity = this.toAccount.city;
      this.toState = this.toAccount.state;
      this.rejectionReason = result.rejectionComment;
      this.requestStatus = result.requestStatus.toUpperCase();;
      this.deliveryOption = result.deliveryOptions;
      this.isExpanded = (result.requestStatus.toUpperCase() === 'EDITING') ? false : true;
      this.formatNewAddedData(result.sotProductList, true);
      this.isEditingRequest = (result.requestStatus.toUpperCase() === 'EDITING') ? true : false;
      this.isEditingOrRejected = (result.requestStatus.toUpperCase() === 'EDITING' || result.requestStatus.toUpperCase() === 'REJECTED');
      this.toAccountName = true;
      this.isEditMode = true;
      this.deliverToAnotherLocation = this.fromDeliveryAccount && this.fromDeliveryAccount > 0 ? true : false;
      this.distanceApiAfterToAcountSelect();
      if (this.fromShipToAccountItems != undefined && this.fromShipToAccountItems != null) {
        const selectedAccount = this.fromShipToAccountItems.filter(x => x.accountNumber == this.fromShipToAccount)[0];
        this.fromParentShipToAccount = selectedAccount.parentNumber;
        this.fromCountry = selectedAccount.country;
        this.fromCity = selectedAccount.city;
        this.subscription.add(this.stockTransferService.getDeliverToLocationList(this.fromShipToAccount, this.fromParentShipToAccount)
          .subscribe((result: any[]) => {
            this.deliveryAccountList = result;
            this.deliverToAnotherLocation = this.fromDeliveryAccount && this.fromDeliveryAccount > 0 ? true : false;
          }, error => this.loaderService.setLoaderStatus(false))
        );
      }

      if (result.requestStatus.toUpperCase() == 'APPROVED'
        || result.requestStatus.toUpperCase() == 'CANCELLED'
        || result.requestStatus.toUpperCase() == 'COMPLETED') {
        this.readOnlyAccess = true;
        this.isFilterAddProductShow = false;
        this.disableWFUArranged = false;
      } else {
        this.disableWFUArrangedButton();
      }

      this.loaderService.setLoaderStatus(false);
      this.enableDisableButtons();
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  setAllFields(field: string, value: any) {
    switch (field) {
      case 'delete':
        this.tabNode = '';
        if (value) {
          this.isAllProductChecked = false;
          this.showTabs = false;
          this.editToolKit = false;
          const productAllList = this.productItemsDataSource.filteredData.filter(x => x.isSelected === true);

          if (productAllList.length == this.productItemsDataSource.data.length) {
            this.errorMsgs = [];
            this.productItemsDataSource = new MatTableDataSource([]);
            this.bindDataSource([]);
            this.sotOriginalProductItemsDataSource = [];
          } else {
            productAllList.forEach(items => {
              let index = this.errorMsgs.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber && element.orderUOM === items.orderUOM;
              });
              if (index !== -1) {
                this.errorMsgs.splice(index, 1);
              }
              index = this.productItemsDataSource.data.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber && element.orderUOM === items.orderUOM;
              });
              if (index !== -1) {
                this.productItemsDataSource.data.splice(index, 1);
              }

              index = this.sotOriginalProductItemsDataSource.findIndex(function (element) {
                return element.itemId === items.itemId && element.lotNumber === items.lotNumber && element.orderUOM === items.orderUOM;
              });
              if (index !== -1) {
                this.sotOriginalProductItemsDataSource.splice(index, 1);
              }
            });
          }

          this.disableWFUArrangedButton();
          this.applyFilterData(this.productFilters);
          this.checkBoxCount = 0;
          this.selectedCount = this.productItemsDataSource.data.length;
          if (this.selectedCount == 0) {
            this.disablecheckbox = true;
          }
          if (this.productItemsDataSource.data.length == 0) {
            this.disablecheckbox = true;
            this.isDraftEnable = false;
            this.isSubmitEnable = false;
          }
        }

        this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true, labelNo: 'No, go back to Request' });
        break;
      default:
        break;
    }
  }

  navigateToLandingPage() {
    this.router.navigate(['/sot-landing']);
  }

  // Show the next error
  nextError() {
    this.index = this.errorMsgs.findIndex(x => x.itemId == this.nextErrorId && x.lotNumber == this.nextLotNumber) + 1;
    if (this.errorMsgs.indexOf(this.errorMsgs[this.index]) != -1) {
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = this.index + 1;
      $('#returnRequestView').scrollTop = 0;
      if ($('#error_' + this.nextErrorId.toString()).offset()) {
        const nextOffset = $('#error_' + this.nextErrorId.toString()).offset().top;
        $('#returnRequestView').animate({ scrollTop: nextOffset }, 1000);
      }
    }
    else {
      this.index = 0;
      this.nextErrorId = this.errorMsgs[this.index].itemId;
      this.nextLotNumber = this.errorMsgs[this.index].lotNumber;
      this.currentErrorRow = 1;
      $('#returnRequestView').scrollTop = 0;
      $('#returnRequestView').animate({ scrollTop: 0 }, 1000);
    }
  }

  // To revert changes
  revertToPreviousError(element: any, isSingleLine) {
    if (element && element != null && this.sotOriginalProductItemsDataSource.length > 0 && this.productItemsDataSource.data.length > 0) {
      if (element && element != null && isSingleLine) {
        // get old data
        const oldLineValue = this.sotOriginalProductItemsDataSource.filter(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber && x.orderUOM === element.orderUOM)[0];
        oldLineValue.lineErrors = { 'itemId': oldLineValue.itemId, 'lotNumber': oldLineValue.lotNumber, 'orderUOM': oldLineValue.orderUOM, 'errors': [] };;

        // get current object index
        const currentLineIndex = this.productItemsDataSource.data.findIndex(x => x.itemId === element.itemId && x.lotNumber === element.lotNumber && x.orderUOM === element.orderUOM);

        // replace current with old object if exist
        if (currentLineIndex != -1) {
          this.productItemsDataSource.data[currentLineIndex] = JSON.parse(JSON.stringify(oldLineValue));
          this.productItemsDataSource.data = this.productItemsDataSource.data;
          const index = this.errorMsgs.findIndex(function (element) {
            return element.itemId === oldLineValue.itemId && element.lotNumber === oldLineValue.lotNumber;
          });
          if (index !== -1) {
            this.errorMsgs.splice(index, 1);
          }

          // to hide one error after revert changes
          this.showHideLineError(oldLineValue.itemId, oldLineValue.lotNumber);
          this.getCommonErrors(this.errorMsgs);
        }
      }
      else {
        // replace whole object
        this.productItemsDataSource.data = JSON.parse(JSON.stringify(this.sotOriginalProductItemsDataSource));
        this.productItemsDataSource.data.forEach(x => {
          x.eligibleUnit = x.isManualLine ? 0 : ((x.invoiceUnits && x.totalReturnUnits) ? (x.invoiceUnits - x.totalReturnUnits) : x.eligibleUnit);
          x.lineErrors = { 'itemId': x.itemId, 'lotNumber': x.lotNumber, 'orderUOM': x.orderUOM, 'errors': [] };
        });

        // To hide common error msg
        this.errorMsgs = new Array();
      }
    }
    if (this.errorMsgs.length > 0) {
      this.showTabs = false;
      this.isSearchClicked = true;
      this.editToolKit = false;
      this.isSubmitEnable = true;
      this.isDraftEnable = true;
    }
    this.broadcastService.broadcast(this.configService.DATA_CHANGE, { editToolKitClick: true, labelNo: 'No, go back to Request' });
  }

  // Revert all changes
  revertAllChanges() {
    this.revertToPreviousError([], false);
    this.hideCommonError();
  }

  // Hide and show error line error
  showHideLineError(errorId: number, lotNumber: string) {
    if (errorId > 0) {
      const errorDiv = $('#error_' + errorId.toString() + '_' + lotNumber);
      if (errorDiv) {
        errorDiv.hide();
      }
    }
    else {
      if (this.errorMsgs && this.errorMsgs.length > 0) {
        this.errorMsgs.forEach(x => {
          const errorDiv = $('#error_' + x.rowId.toString());
          if (errorDiv) {
            errorDiv.show();
          }
        });
      }
    }
  }

  // Hide common error
  hideCommonError() {
    this.showErrorBlock = false;
    this.checkBoxCount = 0;
    this.showTabs = false;
    this.isSearchClicked = true;
    this.editToolKit = false;
    this.isAllProductChecked = false;
  }

  // Hide & show common error
  getCommonErrors(errors: any) {
    if (errors && errors.length > 0) {
      this.errorMsgs = [];
      this.index = 0;
      this.currentErrorRow = 1;
      this.errorMsgs = errors;
      this.showErrorBlock = true;
    }
    else {
      this.showErrorBlock = false;
    }
  }

  validateOrder() {
    let isValidated = true;
    this.errorMsgs = new Array();

    if (this.productItemsDataSource.data && this.productItemsDataSource.data.length > 0) {
      isValidated = true;
      this.productItemsDataSource.data.forEach(x => {
        if (x.lineStatus !== 'REJECTED') {
          x = this.validateQty(x);
          if (x.lineErrors.errors.length > 0) {
            isValidated = false;
          }
        } else {
          x.lineErrors.errors = [];
        }
      });
    }

    if (this.deliveryOption == 4 && (!this.fromContactName)) {
      isValidated = false;
      this.toastrService.error('Please enter a contact name.');
    } else if (this.deliveryOption == 4 && (this.fromContactNumber.length < 10)) {
      isValidated = false;
      this.toastrService.error('Please enter a 10 digit phone number.');
    } else if (this.fromStockPallet == null || this.fromStockPallet < 0 || this.fromStockPallet.toString() === '') {
      isValidated = false;
      this.toastrService.error('Please enter the number of Stock Pallet being transferred.');
    } else if (this.fromNonStockPallet == null || this.fromNonStockPallet < 0 || this.fromNonStockPallet.toString() === '') {
      isValidated = false;
      this.toastrService.error('Please enter the number of non Stock Pallet being transferred.');
    } else if (this.deliveryOption == null || this.deliveryOption <= 0) {
      isValidated = false;
      this.toastrService.error('Please select delivery option.');
    }

    return isValidated;
  }

  validateQty(productItem) {
    productItem.lineErrors = { 'itemId': productItem.itemId, 'lotNumber': productItem.lotNumber, 'orderUOM': productItem.orderUOM, 'errors': [] };
    if (productItem.requestedQty > productItem.availableQuantity) {
      productItem.lineErrors.errors.push({ id: 'requestedQty', error: 'Requested units should be less than or equal to Available Quantity' });
    }
    else if (productItem.requestedQty === '' || productItem.requestedQty === 0 || Number(productItem.requestedQty) === 0) {
      productItem.lineErrors.errors.push({ id: 'requestedQty', error: 'Please enter a request quantity' });
    }
    else if (Number(productItem.requestedQty) < 0) {
      productItem.lineErrors.errors.push({ id: 'requestedQty', error: 'Please enter a positive number request quantity' });
    }
    else {
      productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'requestedQty');
      const index = this.errorMsgs.findIndex(function (element) {
        return element.itemId === productItem.itemId && element.lotNumber === productItem.lotNumber && element.orderUOM === productItem.orderUOM;
      });
      if (index !== -1) {
        this.errorMsgs.splice(index, 1);
      }
    }
    //write warning message
    if (this.fromParentShipToAccount == this.toParentShipToAccount) {
      if (productItem.requestedQty > 0 && Number(productItem.requestedQty) % productItem.conversionFactor > 0) {
        productItem.warningMessage = "Transfer of partial CBOX quantities will not be reflected on your dealer orders.";
      }
      else {
        productItem.warningMessage = "";
      }
    }
    else {
      if (productItem.requestedQty > 0 && Number(productItem.requestedQty) % productItem.conversionFactor > 0) {
        productItem.lineErrors.errors.push({ id: 'conversionFactor', error: 'A user may not transfer an odd quantity for CBOX packaged seed between these retailers' });
      }
      else {
        productItem.lineErrors.errors = productItem.lineErrors.errors.filter(y => y.id != 'conversionFactor');
      }
    }

    if (productItem.lineErrors.errors.length > 0) {
      this.errorMsgs.push(productItem.lineErrors);
      this.getCommonErrors(this.errorMsgs);
    }
    return productItem;
  }

  // On page destroy
  ngOnDestroy() {
    this.stockTransferService.setSOTRequestId(0);

    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  calculateTransferDistance(fromShipToAccount: number, toShipToAccount: number) {
    this.subscription.add(this.stockTransferService.getSotTransferDistance(fromShipToAccount, toShipToAccount).subscribe((result: any) => {
      LolLoggerService.info(result);
      this.travelDistance = result;
      this.loaderService.setLoaderStatus(false);
      this.enableDisableButtons();
    }, error => { this.travelDistance = this.maxTransferDistance + 1; this.loaderService.setLoaderStatus(false); }));
  }

  // For calculating the distance between to and from location
  calculateTransferDistanceClientSide = (from: string, to: string) => {
    const service = new google.maps.DistanceMatrixService();
    // Build request
    if (from != '' && to != '') {
      const request = {
        origins: [from],
        destinations: [to],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
        avoidHighways: false,
        avoidTolls: false,
      };
      // get distance matrix response
      service.getDistanceMatrix(request, (response, status) => this.callbackForDistance(response, status, this));
    }
  };

  // callback function for response resolve
  callbackForDistance = (response, status, that) => {
    if (status == 'OK') {
      const origins = response.originAddresses;
      const destinations = response.destinationAddresses;
      for (let i = 0; i < origins.length; i++) {
        const results = response.rows[i].elements;
        for (let j = 0; j < results.length; j++) {
          const element = results[j];
          if (element.distance) {
            const distancedecimal = element.distance.value * 0.00062137; // converted to Miles
            const distanceRound = parseInt(distancedecimal.toString());
            that.travelDistance = distanceRound;
            LolLoggerService.info('apiCallback:' + that.travelDistance);
            that.disableWFUArrangedButton();
          }
          else {
            LolLoggerService.info('apiCallback:' + that.travelDistance);
            that.travelDistance = this.maxTransferDistance + 1;
          }
        }
      }
    }
  };

  distanceApiAfterToAcountSelect() {
    if (this.fromCity != '' && this.fromCountry != '' && this.toCity != '' && this.toCountry != '') {
      var fromAddress = this.fromCity + ',' + this.fromState + ',' + this.fromCountry;
      var toAddresss = this.toCity + ',' + this.toState + ',' + this.toCountry;
    }
    else {
      var fromAddress = '';
      var toAddresss = '';
    }
    this.calculateTransferDistanceClientSide(fromAddress, toAddresss);
  }

  disableWFUArrangedButton() {
    let totalRequestedQty = 0;
    this.productItemsDataSource.data.map(item => {
      totalRequestedQty += +item.requestedQty;
    });

    //LolLoggerService.info('parent:' + this.fromParentShipToAccount == this.toParentShipToAccount);
    //LolLoggerService.info('fromCountry:' + this.fromCountry + 'toCountry:' + this.toCountry);
    //LolLoggerService.info('maxTransferDistance:' + this.maxTransferDistance);
    //LolLoggerService.info('travelDistance:' + this.travelDistance);
    //LolLoggerService.info('totalRequestedQty:' + totalRequestedQty + 'this.minProductQtyBG' + this.minProductQtyBG);
    if (this.fromParentShipToAccount == this.toParentShipToAccount
      || this.fromCountry != 'USA' || this.toCountry != 'USA' || totalRequestedQty < this.minProductQtyBG
      || this.travelDistance > this.maxTransferDistance
    ) {
      this.disableWFUArranged = true;
      this.deliveryOption = this.deliveryOption == 4 ? 0 : this.deliveryOption;
    }
    else {
      this.disableWFUArranged = false;
    }
    if (this.fromParentShipToAccount == this.toParentShipToAccount) {
      this.disableAlreadyMovedToOrFrom = true;
      this.deliveryOption = (this.deliveryOption == 1 || this.deliveryOption == 2) ? 0 : this.deliveryOption;
    } else {
      this.disableAlreadyMovedToOrFrom = false;
    }
  }

  openResolutionDialog(requestStatus: string) {
    if (this.validateOrder()) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '650px',
        data: { dialogType: 'sotRequestReject', title: 'Resolution Notes' }
      });
      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.resolutionComment = result.comments;
          if (requestStatus === 'REJECTED') {
            this.saveRequest('SUBMITTED');
          } else {
            this.saveRequest('PENDING');
          }
        }
      }));
    }
  }

  // Generate PDF
  generatedPdf(sotRequestId: any) {
    if (sotRequestId) {
      this.stockTransferService.generatePdf(sotRequestId, this.isMobile);
    }
  }

  emailOrderDetail(sotRequestId: any) {
    let emailId = '';
    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      const data = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
      if (data !== null && data !== undefined && data.resultData.length > 0) {
        emailId = data.resultData[0].emailId;
      }
    }
    const emailDialog = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '480px',
      data: { email: emailId, title: 'Send Email', tabNode: this.tabNode, dialogType: 'email' }
    });
    this.subscription.add(emailDialog.afterClosed().subscribe(emailIds => {
      // If user selected Yes
      if (emailIds) {
        const data = {
          SOTRequestId: sotRequestId,
          EmailIds: emailIds
        };
        this.loaderService.setLoaderStatus(true);
        this.subscription.add(this.stockTransferService.sendSOTRequestEmail(data).subscribe(result => {
          if (result) { this.loaderService.setLoaderStatus(false); }
          this.toastrService.success('Email sent');
        }));
      }
    }));
  }

  isHeaderButtonsEnable() {
    if (this.requestStatus == 'SUBMITTED' || this.requestStatus == 'PENDING' || this.requestStatus == 'EDITING' || this.requestStatus == 'APPROVED' || this.requestStatus == 'REJECTED' || this.requestStatus == 'COMPLETED' || this.requestStatus == 'CANCELLED') { return true; }
    else { return false; }
  }
}
